var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33698 3.83203C0.912925 3.83203 0.570312 4.17794 0.570313 4.60322C0.570313 5.0285 0.912925 5.37441 1.33698 5.37441L14.6703 5.37441C15.0944 5.37441 15.437 5.0285 15.437 4.60322C15.437 4.17794 15.0944 3.83203 14.6703 3.83203L1.33698 3.83203ZM12.4481 7.56085L3.5592 7.56085C3.13515 7.56085 2.79254 7.90676 2.79254 8.33204C2.79254 8.75731 3.13515 9.10322 3.5592 9.10322L12.4481 9.10322C12.8722 9.10322 13.2148 8.75731 13.2148 8.33204C13.2148 7.90676 12.8722 7.56085 12.4481 7.56085ZM6.52217 11.2897C6.09811 11.2897 5.7555 11.6356 5.7555 12.0609C5.7555 12.4861 6.09811 12.832 6.52217 12.832L9.48513 12.832C9.90919 12.832 10.2518 12.4861 10.2518 12.0609C10.2518 11.6356 9.90919 11.2897 9.48513 11.2897H6.52217Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.302c0aceaa746f80f07ee1b1c44459d4.svg";
export { ForwardRef as ReactComponent };